import { Typography } from '@mui/material'
import { getLabelFromTranslationData } from '../common/translationsCommon'
import { renderSurveyQuestionToolitp } from './surveyQustions'

const QuestionTitle = ({
  question,
  displayIndex,
  version,
  i18n
}) => {
  let questionText = question.text
  if (!questionText) {
    questionText = getLabelFromTranslationData({
      langVersion: version,
      data: question?.titleValue,
      i18n
    })
    if (question.options) {
      question.options.forEach(option => {
        if (option.titleValue) {
          option.text = getLabelFromTranslationData({
            langVersion: version,
            data: option.titleValue,
            i18n
          })
        }
      })
    }
    question.tooltip = getLabelFromTranslationData({
      langVersion: version,
      data: question?.tooltipValue,
      i18n
    })
  }

  return (
    <div
      className='survey-question-title'
    >
      {question.type === 'HEADER'
        ? (
          <div>
            <Typography
              variant='h5'
              sx={{
                pb: '5px',
                pt: '10px',
                fontSize: 21
              }}
            >
              <b>{`${questionText}`}</b>
            </Typography>
            {question.tooltip && (
              <div style={{ paddingBottom: 5 }}>
                {renderSurveyQuestionToolitp(question.tooltip)}
              </div>
            )}
          </div>
          )
        : (
          <>
            <Typography className='survey-question-header' id={'question-header-' + question.id}>
              {`${displayIndex}. ${questionText}\u00A0${question.isRequired
? ('*')
: ''}`}
            </Typography>
          </>
          )}
    </div>
  )
}

export default QuestionTitle
